module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/014981f410cd18cabdb6f266c3e359b2.png";